module.exports = __webpack_public_path__ + "img/tarif-connect-motiv.ddf83d78.jpg";